import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  popup: {
    zIndex: 2,
  },
}));

export default useStyles;
